<template>
  <div class="detection-page">
    <Header />
    
    <!-- 页面标题区域 -->
    <section class="page-header">
      <div class="container">
        <div class="header-content">
          <h1 class="page-title">报告查真伪</h1>
          <p class="page-subtitle">先进设备，专业团队，精准检测</p>
          <div class="breadcrumb">
            <router-link to="/">首页</router-link>
            <span class="separator">/</span>
            <span class="current">报告查真伪</span>
          </div>
        </div>
      </div>
    </section>
    
    <!-- 报告编号查找报告 -->
    <section class="report-search">
      <div class="container">
        <div class="search-content">
          <h2 class="search-title">报告编号查找报告</h2>
          <p class="search-description">请输入您的报告编号，快速查找检测报告</p>
          <div class="search-form">
            <div class="search-input-group">
              <input 
                type="text" 
                v-model="sampleNumber" 
                placeholder="请输入完整的报告编号" 
                class="search-input"
                @keyup.enter="searchReport"
              />
              <button 
                @click="searchReport"
                @touchstart="searchReport"
                class="search-btn"
                :disabled="!sampleNumber.trim() || isSearching"
              >
                <i class="fas fa-search" v-if="!isSearching"></i>
                <i class="fas fa-spinner fa-spin" v-else></i>
                {{ isSearching ? '查找中...' : '查找报告' }}
              </button>
            </div>
            <div v-if="searchError" class="search-error">
              <i class="fas fa-exclamation-triangle"></i>
              {{ searchError }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 检测中心概览 -->






    <!-- 质量保证体系 -->






    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Detection',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      // 报告编号查找相关数据
      sampleNumber: '',
      isSearching: false,
      searchError: '',
      capabilities: [
        {
          id: 'chemical',
          title: '化学成分分析',
          icon: 'fas fa-flask',
          description: '精确检测各类样品中的化学成分含量',
          items: [
            { name: '蛋白质', range: '0.1-100%' },
            { name: '脂肪', range: '0.05-100%' },
            { name: '水分', range: '0.01-100%' },
            { name: '灰分', range: '0.01-50%' }
          ]
        },
        {
          id: 'trace',
          title: '痕量元素检测',
          icon: 'fas fa-atom',
          description: '检测样品中微量和痕量元素含量',
          items: [
            { name: '重金属', range: 'ppb-ppm级' },
            { name: '稀土元素', range: 'ppt-ppb级' },
            { name: '营养元素', range: 'ppm-百分比级' },
            { name: '有害元素', range: 'ppt-ppm级' }
          ]
        },
        {
          id: 'organic',
          title: '有机污染物检测',
          icon: 'fas fa-leaf',
          description: '检测各类有机污染物和残留物',
          items: [
            { name: '农药残留', range: 'μg/kg级' },
            { name: 'VOCs', range: 'μg/m³级' },
            { name: 'PAHs', range: 'ng/g级' },
            { name: 'PCBs', range: 'ng/g级' }
          ]
        },
        {
          id: 'microbiology',
          title: '微生物检测',
          icon: 'fas fa-bacteria',
          description: '检测各类微生物指标和病原菌',
          items: [
            { name: '细菌总数', range: 'CFU/g或CFU/mL' },
            { name: '大肠菌群', range: 'MPN/g或MPN/mL' },
            { name: '致病菌', range: '定性检测' },
            { name: '霉菌酵母', range: 'CFU/g或CFU/mL' }
          ]
        }
      ],
      qualityFeatures: [
        {
          id: 1,
          title: 'ISO 17025认证',
          description: '通过国际实验室认可标准，确保检测结果的准确性和可靠性',
          icon: 'fas fa-certificate'
        },
        {
          id: 2,
          title: '全程质量控制',
          description: '从样品接收到报告出具，全程实施严格的质量控制措施',
          icon: 'fas fa-shield-alt'
        },
        {
          id: 3,
          title: '标准化操作',
          description: '严格按照国家和国际标准进行检测操作，确保结果的一致性',
          icon: 'fas fa-cogs'
        },
        {
          id: 4,
          title: '持续改进',
          description: '定期参加能力验证和比对试验，持续提升检测能力和水平',
          icon: 'fas fa-chart-line'
        }
      ],
      certifications: [
        {
          id: 1,
          name: 'ISO 17025实验室认可',
          description: '国际实验室认可标准，确保检测和校准实验室的能力',
          image: 'https://via.placeholder.com/200x150/3b82f6/ffffff?text=ISO17025',
          number: 'CNAS L1234',
          validDate: '2025-12-31'
        },
        {
          id: 2,
          name: 'CMA计量认证',
          description: '中国计量认证，具有法律效力的检测资质',
          image: 'https://via.placeholder.com/200x150/1e40af/ffffff?text=CMA',
          number: '2023001234CMA',
          validDate: '2026-06-30'
        },
        {
          id: 3,
          name: 'CATL农产品质量安全检测',
          description: '农产品质量安全检测机构认证',
          image: 'https://via.placeholder.com/200x150/2563eb/ffffff?text=CATL',
          number: 'CATL-2023-001',
          validDate: '2025-12-31'
        },
        {
          id: 4,
          name: 'ILAC-MRA国际互认',
          description: '国际实验室认可合作组织互认协议',
          image: 'https://via.placeholder.com/200x150/1d4ed8/ffffff?text=ILAC',
          number: 'ILAC-MRA-2023',
          validDate: '2025-12-31'
        }
      ]
    }
  },
  methods: {
    // 查找报告方法
    async searchReport(event) {
      // 防止重复触发
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      
      if (!this.sampleNumber.trim()) {
        this.searchError = '请输入报告编号';
        return;
      }

      // 防止重复点击
      if (this.isSearching) {
        return;
      }

      this.isSearching = true;
      this.searchError = '';

      try {
        // 调用后端API查找报告，添加时间戳防止缓存
        const timestamp = new Date().getTime()
        const response = await fetch(`/api/reports/search/${this.sampleNumber.trim()}?_t=${timestamp}`, {
          cache: 'no-cache',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        });
        
        if (response.ok) {
          const reportData = await response.json();
          if (reportData && reportData.success && reportData.data && reportData.data.reportUrl) {
            // 移动端友好的报告打开方式
            this.openReport(reportData.data.reportUrl);
          } else {
            this.searchError = '未找到该报告编号对应的报告';
          }
        } else if (response.status === 404) {
          this.searchError = '未找到该报告编号对应的报告';
        } else {
          this.searchError = '查找报告时发生错误，请稍后重试';
        }
      } catch (error) {
        console.error('查找报告错误:', error);
        this.searchError = '网络连接错误，请检查网络后重试';
      } finally {
        this.isSearching = false;
      }
    },

    // 智能打开报告方法
    openReport(reportUrl) {
      // 检测是否为移动设备
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      if (isMobile) {
        // 移动端：直接跳转到报告页面
        window.location.href = reportUrl;
      } else {
        // 桌面端：尝试在新窗口打开，如果失败则直接跳转
        const newWindow = window.open(reportUrl, '_blank');
        
        // 检查是否被弹窗拦截
        if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
          // 被拦截时，询问用户是否直接跳转
          if (confirm('浏览器阻止了弹窗，是否直接跳转到报告页面？')) {
            window.location.href = reportUrl;
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.detection-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

/* 页面标题区域 */
.page-header {
  background: 
    linear-gradient(135deg, rgba(30, 64, 175, 0.4) 0%, rgba(59, 130, 246, 0.4) 50%, rgba(96, 165, 250, 0.4) 100%),
    url('@/assets/img/banner5.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: scroll;
  color: white;
  padding: 120px 0 80px;
  position: relative;
  overflow: hidden;
  min-height: 400px;
}

/* 移动端背景适配：优化裁剪与空间 */
@media (max-width: 768px) {
  .page-header {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 100px 0 60px;
    min-height: max(340px, calc(100vw * 9 / 16));
  }
}

.page-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  opacity: 0.3;
}

.header-content {
  position: relative;
  z-index: 2;
  text-align: center;
}

.page-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.page-subtitle {
  font-size: 1.25rem;
  opacity: 0.9;
  margin-bottom: 2rem;
}

.breadcrumb {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
}

.breadcrumb a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: white;
}

.separator {
  opacity: 0.6;
}

.current {
  color: white;
  font-weight: 500;
}

/* 报告编号查找报告 */
.report-search {
  padding: 4rem 0;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
}

.search-content {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

.search-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1rem;
  position: relative;
}

.search-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  border-radius: 2px;
}

.search-description {
  font-size: 1.125rem;
  color: #6b7280;
  margin-bottom: 2.5rem;
  line-height: 1.6;
}

.search-form {
  max-width: 500px;
  margin: 0 auto;
}

.search-input-group {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.search-input {
  flex: 1;
  padding: 1rem 1.5rem;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
}

.search-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-btn {
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
  /* 触摸支持 */
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  min-height: 44px; /* iOS推荐的最小触摸目标 */
  user-select: none;
}

.search-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.search-btn:active:not(:disabled) {
  background: linear-gradient(135deg, #1d4ed8, #1e3a8a);
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.2);
}

.search-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.search-error {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #dc2626;
  font-size: 0.875rem;
  padding: 0.75rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  margin-top: 1rem;
}

.search-error i {
  font-size: 1rem;
}

/* 检测中心概览 */
.center-overview {
  padding: 5rem 0;
  background: white;
}

.overview-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1.5rem;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  /* background: linear-gradient(135deg, #3b82f6, #1e40af); */
  border-radius: 2px;
}

.section-description {
  font-size: 1.125rem;
  color: #6b7280;
  line-height: 1.8;
  margin-bottom: 3rem;
}

.overview-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  background: linear-gradient(135deg, #f8fafc, #e2e8f0);
  border-radius: 20px;
  transition: transform 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
}

.stat-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  flex-shrink: 0;
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  color: #3b82f6;
  margin-bottom: 0.25rem;
}

.stat-label {
  color: #6b7280;
  font-weight: 500;
}



/* 检测能力 */
.detection-capabilities {
  padding: 5rem 0;
  background: white;
}

.capabilities-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.capability-card {
  background: #f8fafc;
  padding: 2rem;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.capability-card:hover {
  background: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
}

.capability-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.capability-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  color: white;
}

.capability-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
}

.capability-description {
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.capability-items {
  display: grid;
  gap: 0.75rem;
}

.capability-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: white;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.item-name {
  font-weight: 500;
  color: #1f2937;
}

.item-range {
  color: #3b82f6;
  font-weight: 500;
  font-size: 0.875rem;
}

/* 质量保证体系 */
.quality-system {
  padding: 5rem 0;
  background: #f8fafc;
}

.quality-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  margin-top: 3rem;
}

.quality-image img {
  width: 100%;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.quality-features {
  display: grid;
  gap: 2rem;
}

.quality-feature {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.feature-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  color: white;
  flex-shrink: 0;
}

.feature-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
}

.feature-description {
  color: #6b7280;
  line-height: 1.6;
}

/* 认证资质 */
.certifications {
  padding: 5rem 0;
  background: white;
}

.certifications-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.certification-card {
  background: #f8fafc;
  padding: 2rem;
  border-radius: 20px;
  text-align: center;
  transition: all 0.3s ease;
}

.certification-card:hover {
  background: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
}

.cert-image {
  margin-bottom: 1.5rem;
}

.cert-image img {
  width: 120px;
  height: 90px;
  object-fit: cover;
  border-radius: 10px;
}

.cert-name {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.75rem;
}

.cert-description {
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.cert-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;
}

.cert-number,
.cert-date {
  color: #6b7280;
}



/* 响应式设计 */
@media (max-width: 768px) {
  .page-title {
    font-size: 2.5rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .quality-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .overview-stats {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .stat-card {
    flex-direction: column;
    text-align: center;
  }
  
  .search-title {
    font-size: 2rem;
  }
  
  .search-input-group {
    flex-direction: column;
    gap: 1rem;
  }
  
  .search-btn {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .page-header {
    padding: 100px 0 60px;
  }
  
  .page-title {
    font-size: 2rem;
  }
  
  .overview-stats {
    grid-template-columns: 1fr;
  }
  
  .capabilities-grid,
  .certifications-grid {
    grid-template-columns: 1fr;
  }
  
  .capability-card,
  .certification-card {
    margin: 0 1rem;
  }
  
  .search-title {
    font-size: 1.75rem;
  }
  
  .search-content {
    padding: 0 1rem;
  }
  
  .search-input,
  .search-btn {
    padding: 0.875rem 1.25rem;
  }
}
</style>